import reducer from './advisorsReducer';
import actions from './advisorsActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
